"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pinkA_exports = {};
__export(pinkA_exports, {
  pinkA: () => pinkA
});
module.exports = __toCommonJS(pinkA_exports);
const pinkA = {
  pinkA1: "hsla(0, 0%, 0%, 0)",
  pinkA2: "hsla(320, 98.1%, 64.1%, 0.036)",
  pinkA3: "hsla(320, 99.1%, 63.1%, 0.121)",
  pinkA4: "hsla(320, 99.5%, 62.7%, 0.170)",
  pinkA5: "hsla(319, 99.7%, 61.5%, 0.219)",
  pinkA6: "hsla(322, 99.4%, 60.8%, 0.291)",
  pinkA7: "hsla(321, 99.6%, 58.7%, 0.407)",
  pinkA8: "hsla(322, 99.7%, 55.4%, 0.608)",
  pinkA9: "hsla(322, 100%, 64.6%, 0.817)",
  pinkA10: "hsla(323, 100%, 66.3%, 0.875)",
  pinkA11: "hsla(325, 99.9%, 68.6%, 0.960)",
  pinkA12: "hsla(314, 100%, 96.9%, 0.980)"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  pinkA
});
//# sourceMappingURL=pinkA.js.map
